import {
  Box,
  useTheme,
  TextField,
  Grid,
  InputLabel,
  FormControl,
  Select,
  Button,
  MenuItem,
} from "@mui/material";
import { useState } from "react";
import { tokens } from "../../theme";
import swal from "sweetalert";
import Header from "../../components/Header";
import axios from "axios";
import Web3 from "web3";
import CircularProgress from "@mui/material/CircularProgress";

const TestConfig = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [nftTokenGatingInputFields, setNftTokenGatingInputFields] = useState({
    blockChain: "",
    tokenStandard: "",
    contractAddress: "",
    tokenId: "",
    nftsRequired: "",
  });

  const onHandleNftTokenGatingInputChange = (event) => {
    const { name, value } = event.target;
    setNftTokenGatingInputFields({
      ...nftTokenGatingInputFields,
      [name]: value,
    });
  };
  const handleNFTCheck = async (event) => {
    try {
      event.preventDefault();
      var web3Modal;
      const Web3Modal = window.Web3Modal.default;
      const WalletConnectProvider = window.WalletConnectProvider.default;
      var provider;
      web3Modal = new Web3Modal({
        network: "mainnet",
        cacheProvider: true,
        providerOptions: {
          walletconnect: {
            package: WalletConnectProvider,
            options: {
              infuraId: process.env.REACT_APP_INFURA_ID,
            },
          },
        },
      });

      await web3Modal.clearCachedProvider();
      localStorage.removeItem("walletconnect");
      localStorage.removeItem("WEB3_CONNECT_CACHED_PROVIDER");
      provider = await web3Modal.connect();
      const web3 = new Web3(provider);
      const accounts = await web3.eth.getAccounts();
      // MetaMask does not give you all accounts, only the selected account
      const selectedAccount = accounts[0];
      let address = selectedAccount;
      var signature = await web3.eth.personal.sign("nonce", address);
      setLoadingScreen(true);
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/nft-check-balance?signature=${signature}`,
          {
            nftTokenGatingInputFields,
          },
          {
            headers: {
              "content-type": "application/json",
              token: localStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          setLoadingScreen(false);
          swal({
            text: res.data.title,
            icon: "success",
          });
        })
        .catch((err) => {
          setLoadingScreen(false);
          swal({
            text: err.response.data.title,
            icon: "error",
          });
        });
    } catch (err) {}
  };
  return (
    <Box m="20px">
      <Header
        title="Test Configuration"
        subtitle="Fill the required field to check NFT balance in your wallet"
      />
      <Box mt="40px" sx={{ boxShadow: "4" }} mr="90px" backgroundColor="white">
        <div>
          {loadingScreen && (
            <div
              style={{
                opacity: "1 !important",
                zIndex: "2",
                textAlign: "center",
                position: "absolute",
                marginLeft: "26.5%",
                marginTop: "5%",
              }}
            >
              <CircularProgress />
            </div>
          )}
          <Box
            sx={{
              mt: 1,
              ml: 3,
              width: 1100,
              "& Grid": {
                color: colors.greenAccent[300],
              },
            }}
          >
            <form onSubmit={handleNFTCheck}>
              <Grid container rowSpacing={2} columnSpacing={2} sx={{ mt: 3 }}>
                <Grid item md={5} sm={5} xs={5}>
                  <FormControl sx={{ mt: 2, boxShadow: 2 }} fullWidth required>
                    <InputLabel id="demo-simple-select-label">
                      Select BlockChain
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="blockChain"
                      label="Select BlockChain"
                      value={nftTokenGatingInputFields.blockChain}
                      onChange={onHandleNftTokenGatingInputChange}
                    >
                      <MenuItem value={"Ethereum"}>Ethereum</MenuItem>
                      <MenuItem value={"Polygon"}>Polygon</MenuItem>
                      <MenuItem value={"POAP/xDai"}>POAP/xDai</MenuItem>
                      <MenuItem value={"Sepolia-Ethereum"}>
                        Sepolia Ethereum
                      </MenuItem>
                      <MenuItem value={"Base-Mainnet"}>Base Mainnet</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item md={5} sm={5} xs={5}>
                  <FormControl
                    sx={{ ml: 3, mt: 2, boxShadow: 2 }}
                    fullWidth
                    required
                  >
                    <InputLabel id="demo-simple-select-label">
                      Token Standard
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="tokenStandard"
                      label="Token Standard"
                      value={nftTokenGatingInputFields.tokenStandard}
                      onChange={onHandleNftTokenGatingInputChange}
                    >
                      <MenuItem value={"ERC20"}>ERC20</MenuItem>
                      <MenuItem value={"ERC721"}>ERC721</MenuItem>
                      <MenuItem value={"ERC1155"}>ERC1155</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item md={5} sm={5} xs={5}>
                  <TextField
                    sx={{ boxShadow: 2, mt: 2 }}
                    fullWidth
                    required
                    name="contractAddress"
                    value={nftTokenGatingInputFields.contractAddress}
                    label={
                      nftTokenGatingInputFields.blockChain === "POAP/xDai"
                        ? "Event ID"
                        : "Contract Address"
                    }
                    type="text"
                    id="contractAddress"
                    autoComplete="name"
                    onChange={onHandleNftTokenGatingInputChange}
                  />
                </Grid>
                <Grid item md={5} sm={5} xs={5}>
                  <TextField
                    sx={{ ml: 3, boxShadow: 2, mt: 2 }}
                    fullWidth
                    name="tokenId"
                    value={nftTokenGatingInputFields.tokenId}
                    label="Token Id"
                    type="text"
                    id="tokenId"
                    autoComplete="name"
                    onChange={onHandleNftTokenGatingInputChange}
                  />
                </Grid>
                <Grid item md={10.3} sm={10.3} xs={10.3}>
                  <TextField
                    sx={{ boxShadow: 2, mt: 2 }}
                    required
                    fullWidth
                    name="nftsRequired"
                    value={nftTokenGatingInputFields.nftsRequired}
                    label="NFTs/Tokens Required"
                    inputProps={{ type: "number", min: 1 }}
                    id="nftsRequired"
                    autoComplete="name"
                    onChange={(event) => {
                      const value = event.target.value;
                      if (value === "" || value > 0) {
                        onHandleNftTokenGatingInputChange(event);
                      }
                    }}
                  />
                </Grid>
                <Grid item md={5} sm={5} xs={5}>
                  <Button
                    className="custom-color-button"
                    variant="contained"
                    color="info"
                    type="Submit"
                    sx={{
                      mt: 4,
                      mb: 3,

                      width: 150,
                      height: 40,
                    }}
                  >
                    Connect Wallet
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </div>
      </Box>
    </Box>
  );
};

export default TestConfig;
